import { fetcher } from '../../http/Fetcher';

const storagePath = (fruitSliceId: string) =>
    `/api/admin/fruit-slices/${encodeURIComponent(fruitSliceId)}/storage`;

export async function loadFruitSliceStorage(
    fruitSliceId: string,
): Promise<Record<string, unknown>> {
    return await fetcher<Record<string, unknown>>({
        endpoint: storagePath(fruitSliceId),
        method: 'GET',
    });
}

export async function saveFruitSliceStorage(
    fruitSliceId: string,
    scope: string,
    data: unknown,
): Promise<void> {
    await fetcher({
        endpoint: storagePath(fruitSliceId),
        method: 'PATCH',
        body: JSON.stringify({ scope, data }),
    });
}
